/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BusinessPhysicalAddressGeoPoint } from './BusinessPhysicalAddressGeoPoint';
import {
    BusinessPhysicalAddressGeoPointFromJSON,
    BusinessPhysicalAddressGeoPointFromJSONTyped,
    BusinessPhysicalAddressGeoPointToJSON,
} from './BusinessPhysicalAddressGeoPoint';
import type { RedemptionBusiness } from './RedemptionBusiness';
import {
    RedemptionBusinessFromJSON,
    RedemptionBusinessFromJSONTyped,
    RedemptionBusinessToJSON,
} from './RedemptionBusiness';

/**
 * 
 * @export
 * @interface RedemptionListBusiness
 */
export interface RedemptionListBusiness {
    /**
     * 
     * @type {string}
     * @memberof RedemptionListBusiness
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionListBusiness
     */
    readonly name: string;
    /**
     * 
     * @type {boolean}
     * @memberof RedemptionListBusiness
     */
    readonly is_open: boolean;
    /**
     * 
     * @type {string}
     * @memberof RedemptionListBusiness
     */
    readonly currency_symbol: string;
    /**
     * 3-letter ISO currency code. See https://stripe.com/docs/currencies.
     * @type {string}
     * @memberof RedemptionListBusiness
     */
    readonly currency_code: string;
    /**
     * IETF BCP 47 language tag.
     * @type {string}
     * @memberof RedemptionListBusiness
     */
    readonly language_code: string;
    /**
     * 
     * @type {BusinessPhysicalAddressGeoPoint}
     * @memberof RedemptionListBusiness
     */
    physical_address_geo_point: BusinessPhysicalAddressGeoPoint | null;
}

/**
 * Check if a given object implements the RedemptionListBusiness interface.
 */
export function instanceOfRedemptionListBusiness(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "is_open" in value;
    isInstance = isInstance && "currency_symbol" in value;
    isInstance = isInstance && "currency_code" in value;
    isInstance = isInstance && "language_code" in value;
    isInstance = isInstance && "physical_address_geo_point" in value;

    return isInstance;
}

export function RedemptionListBusinessFromJSON(json: any): RedemptionListBusiness {
    return RedemptionListBusinessFromJSONTyped(json, false);
}

export function RedemptionListBusinessFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedemptionListBusiness {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'is_open': json['is_open'],
        'currency_symbol': json['currency_symbol'],
        'currency_code': json['currency_code'],
        'language_code': json['language_code'],
        'physical_address_geo_point': BusinessPhysicalAddressGeoPointFromJSON(json['physical_address_geo_point']),
    };
}

export function RedemptionListBusinessToJSON(value?: RedemptionListBusiness | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'physical_address_geo_point': BusinessPhysicalAddressGeoPointToJSON(value.physical_address_geo_point),
    };
}

